type DisclaimerProps = {
	extraMargin: boolean;
};

export default function Disclaimer(props: DisclaimerProps) {
	var { extraMargin } = props;
	const version = process.env.REACT_APP_VERSION;

	return (
		<div className={extraMargin ? 'disclaimer extra-margin' : 'disclaimer'} style={{ position: 'relative' }}>
			<div className='disclaimer-content'>
				* Data is sourced from internal systems and 3rd party data providers to MISO and is considered preliminary and provided at best effort.
			</div>
			<div
				style={{
					position: 'absolute',
					bottom: 4,
					right: 12,
					fontSize: '12px',
					color: '#888'
				}}>
				{version}
			</div>
		</div>
	);
}
